module.exports = __webpack_public_path__ + "img/close-icon.f66e3340.svg";